import { ROLES } from '@/constants/roles';

const routes = [
  {
    path: '/organization-team-manage/stage/:id',
    component: () => import('./views/StageTeamMange/index.vue'),
    meta: {
      title: 'Управление организаторами',
      accessList: [ROLES.organization],
      layout: 'ui-design',
      back: true,
    },
  },
  {
    path: '/organization/events/manage',
    name: 'organization-events-manage',
    component: () => import('./views/OrganizationEventsManage/index.vue'),
    meta: {
      title: 'Управление организаторами',
      accessList: [ROLES.organization],
      layout: 'ui-design',
      back: true,
    },
  },
];

export default routes;
